/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_52146586"]'><div :class='["radio-modal-default-demo"]'><cube-radio-modal ref="__mpx_ref_radioModal__" title="请选择支付方式" subtitle="将按已选择的支付方式优先支付，若不支持该支付方式的⻋型则默认为上次所选支付方式" :show-close-icon="(true)" :options="(options)" :value="(checkedValue)" @close='(e)=>__invoke(e, [["onClose"]])' @confirm='(e)=>__invoke(e, [["onConfirm"]])'/><cube-button @_click="onTap">radio-modal-default</cube-button></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_52146586"}'>
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_52146586"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_52146586"}
  /** script content **/
  require("./radio-modal-default.mpx.js?isComponent&outputPath=components%2Fradio-modal-default52146586%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./radio-modal-default.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fradio-modal-default52146586%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_52146586"],
    ctorType: "component",
    outputPath: "components/radio-modal-default52146586/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-radio-modal':getComponent(require("../../../packages/mpx-cube-ui/src/components/radio-modal/index.mpx?isComponent&outputPath=components%2Findex253dfa48%2Findex")),'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>